const $$splitComponentImporter = () => import('/app/src/routes/dashboard/admin/cancellation-requests.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/dashboard/admin/cancellation-requests")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});